import hrms12xLabels from 'assets/labels/hrms12x'
import faker from 'faker'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hrms12xLabels
    }
  },
  index () {
    let mockPath = '\\\\192.168.2.18\\temp\\temp\\'
    let mockRows = []
    const mockTotal = 50
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        // no: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        desc_codcomp: faker.name.jobType(),
        desc_codpos: faker.name.title(),
        codcomp: faker.random.word(),
        codpos: faker.random.word(),
        email: faker.internet.email()
      })
    }

    return {
      path: mockPath,
      table: {
        total: mockTotal,
        rows: mockRows
      }
    }
  },
  sendmail () {
    let mockSendmail = {
      subject: '',
      mgs: '',
      attach: '',
      codempid_sender: '',
      codcomp_sender: '',
      reciver: '',
      codempid: '',
      email: ''
    }

    return mockSendmail
  },
  send () {
    return labels.mockPostMessage
  },
  listFields () {
    let mockRowsEn = [
      { code: 'codempid', description: 'Employee Code', type: 'varchar2' },
      { code: 'numlvl', description: 'Number Level', type: 'number' },
      { code: 'codpos', description: 'Position Code', type: 'varchar2' },
      { code: 'dtestrt', description: 'Start Date', type: 'date' }
    ]

    let mockRowsTh = [
      { code: 'codempid', description: 'รหัสพนักงาน', type: 'varchar2' },
      { code: 'numlvl', description: 'ระดับ', type: 'number' },
      { code: 'codpos', description: 'รหัสตำแหน่ง', type: 'varchar2' },
      { code: 'dtestrt', description: 'วันที่เริ่มต้น', type: 'date' }
    ]

    return {
      en: mockRowsEn,
      th: mockRowsTh
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms12x/mocker.js